import { createApp, reactive } from 'vue';
import App from './App.vue';
import router from "@/router";
import { stateSymbol, createState } from '@/state';

const vm = createApp(App)
    .use(router)
    .provide(stateSymbol, createState())
    .mount('#app');
